// @flow
/* eslint-env browser */

import * as React from 'react';

function useOnClickOutside<T: HTMLElement>(
  ref: { current: T | null, ... },
  handler: (evt: MouseEvent | TouchEvent) => void,
) {
  React.useEffect(() => {
    const listener = (evt: MouseEvent | TouchEvent) => {
      if (
        !ref.current ||
        (evt.target instanceof Node && ref.current.contains(evt.target))
      ) {
        return;
      }

      handler(evt);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}

export { useOnClickOutside };
